import { render, staticRenderFns } from "./SelecionarDestinatarios.vue?vue&type=template&id=2a534564"
import script from "./SelecionarDestinatarios.vue?vue&type=script&lang=js"
export * from "./SelecionarDestinatarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports